// Info-icon tooltip text for the Employee dashboard counters (QA-approved wording).

export const ACTIVE_PERMITS_TOOLTIPS = {
  section: 'These three span all your branches, not just the selected one.',
  waiting:
    "Unpaid invoices on permits where you're the Permit Manager, across all your branches. " +
    "Fees that are voided or marked paid manually aren't counted.",
  active:
    'All permits whose project you manage, except those marked Completed or Withdrawn. ' +
    'Spans all your branches.',
  progress:
    "Approved proposals on permits where you're the Permit Manager. " +
    "This is work that's been approved and is now underway.",
};

export const TASK_SHEET_TOOLTIPS = {
  section: 'These are scoped to the branch selected at the top.',
  invoices: 'Outstanding fee activities assigned to you in this branch. Click to open them in All Activities.',
  tickets: 'Pending tickets you created in this branch. Click to see the list below.',
  documents:
    'Permits you manage that have at least one pending document. ' +
    'The number counts permits, not documents. Click to see the list below.',
  reviews: '"PM/PT processing" reviews assigned to you that are still pending. Click to see the list below.',
  conditions: 'Conditions assigned to you that are "Under review." Click to see the list below.',
};

// Employee "Monthly Sales Report" only; the Branch Admin proposal graph keeps
// PROPOSAL_GRAPH_DESCRIPTION.
export const MONTHLY_SALES_REPORT_DESCRIPTION =
  'Proposals created vs. approved each month this year. Hover a bar for details.';
